import { create } from 'zustand';

/**
 * Señal cross-hook para re-leer promociones del cache local.
 * `usePosCartPromotions` la escucha; el checkout la emite tras el
 * force-sync de catálogo para no evaluar con promos stale
 * (module-audit X-PROM-P2b).
 */
export const usePromotionsReloadBus = create<{ nonce: number; bump: () => void }>(
  (set) => ({
    nonce: 0,
    bump: () => set((s) => ({ nonce: s.nonce + 1 })),
  }),
);
